// extracted by css-extract-rspack-plugin
export default {"container":"_aca53739","heading":"_d6f707b6","designItems":"_a3023f4a"};